let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8FOl8")).then(() => parcelRequire('k9vj7'));